import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';
import { ROLES } from '@/auth/enums/auth.enum';

export const MY_CONTENT_MENU_NAME = {
  MY_CONTENT: 'myContent',
  PURCHASED: 'purchased',
  SUBJECTS: 'subjects'
}

export const ALL_CONTENT_MENU = [
  {
    name: 'purchased',
    disabled: false,
    path: 'private.myContent.all.purchased',
    hideForRoles: [
      ROLES.EDUAC_AUTHOR,
    ]
  },
  {
    name: 'templates',
    disabled: false,
    path: 'private.myContent.all.templates',
    hideForRoles: [
      ROLES.EDUAC_STUDENT,
      ROLES.EDUAC_SUBSTITUTE_TEACHER,
    ]
  },
  {
    name: 'subjects',
    disabled: false,
    path: 'private.myContent.all.subjects',
    hideForRoles: [
      ROLES.EDUAC_AUTHOR,
      ROLES.EDUAC_STUDENT,
      ROLES.EDUAC_SUBSTITUTE_TEACHER,
    ]
  },
  {
    name: 'fileManager',
    disabled: true
  }
];

export const ALL_CONTENT_ROUTES_DEFAULT = [
  {
    defaultRoute: 'private.myContent.all.templates',
    forRoles: [
      ROLES.EDUAC_AUTHOR,
    ]
  },
  {
    defaultRoute: 'private.myContent.all.purchased',
    forRoles: [
      ROLES.EDUAC_STUDENT,
      ROLES.EDUAC_SUBSTITUTE_TEACHER,
    ]
  },
]

export const MY_CONTENT_TYPES = {
  COURSES: 'courses',
  BOOKS: 'books',
  COURSE: 'COURSE',
  BOOK: 'BOOK'
}

export const MENU_IDS = {
  VIEW: 'VIEW',
  DOWNLOAD: 'DOWNLOAD',
  REMOVE: 'REMOVE',
  EDIT_CONTENT: 'EDIT_CONTENT',
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  MAKE_TEMPLATE: 'MAKE_TEMPLATE',
  COURSE_ADMIN: 'COURSE_ADMIN',
  SEE_PROCESS: 'SEE_PROCESS',
  SUBJECT_BUILDER: 'SUBJECT_BUILDER',
  RESOLVE_CONFLICTS: 'RESOLVE_CONFLICTS'
}


/* CREATE/DRAFT MENU */
export const DRAFT_ITEM_MENU_COURSES = [{
  id: MENU_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
},
{
  id: MENU_IDS.EDIT_CONTENT,
  text: 'myContent.itemMenu.editContent',
  borderBottom: true,
},
{
  id: MENU_IDS.EDIT_PRODUCT,
  text: 'myContent.itemMenu.editDescription',
  borderBottom: true,
},
{
  id: MENU_IDS.MAKE_TEMPLATE,
  text: 'myContent.itemMenu.copyToTemplate',
  borderBottom: true,
},
{
  id: MENU_IDS.COURSE_ADMIN,
  text: 'myContent.itemMenu.courseAdmin',
  borderBottom: true
},
{
  id: MENU_IDS.SEE_PROCESS,
  text: 'myContent.itemMenu.seeProcess',
  borderBottom: true
},
{
  id: MENU_IDS.SUBJECT_BUILDER,
  text: 'myContent.itemMenu.subjectBuilder',
  borderBottom: true
},
{
  id: MENU_IDS.RESOLVE_CONFLICTS,
  text: 'myContent.itemMenu.resolveConflicts',
  borderBottom: true
},
{
  id: MENU_IDS.REMOVE,
  text: 'myContent.itemMenu.remove',
  borderBottom: true
}];


/* PURCHASED MENU */
export const PURCHASED_ITEM_MENU_BOOKS = [{
  id: MENU_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
},
{
  id: MENU_IDS.DOWNLOAD,
  text: 'myContent.itemMenu.download',
  borderBottom: true,
  type: '',
}];

export const PURCHASED_ITEM_MENU_COURSES = [{
  id: MENU_IDS.VIEW,
  text: 'myContent.itemMenu.view',
  borderBottom: true,
}];

export const MY_CONTENT_ITEM_MENU: any = {
  subjects_courses: DRAFT_ITEM_MENU_COURSES,
  purchased_courses: PURCHASED_ITEM_MENU_COURSES
}
